import { FlattenedPage, PageCategory } from "@types-runway/questionnaire";

export type ProgressSection = "aboutYou" | "yourTrip" | "yourHealth";

export const progressSections: readonly ProgressSection[] = ["aboutYou", "yourTrip", "yourHealth"];

export const progressSectionNames: Record<ProgressSection, string> = {
  aboutYou: "About you",
  yourTrip: "Your trip",
  yourHealth: "Your health",
};

const sectionByCategory: Record<PageCategory, ProgressSection> = {
  introduction: "aboutYou",
  user: "aboutYou",
  trip: "yourTrip",
  medical: "yourHealth",
  conditions: "yourHealth",
  marketing: "yourHealth",
  consent: "yourHealth",
};

export const sectionOfPage = (page: Pick<FlattenedPage, "section">): ProgressSection =>
  sectionByCategory[page.section];
